module.exports = __webpack_public_path__ + "img/UTFREM.6116a6c9.png";